import { useCallback } from 'react';

import { usePageMeta } from '../usePageMeta';

interface UseFitnessAuthProps {
  clientID: string;
  scope: string;
  authUrl: string;
  responseType: string;
  callbackDomain: string;
}

export default function useFitnessAuth({
  clientID,
  callbackDomain,
  authUrl,
  responseType,
  scope,
}: UseFitnessAuthProps) {
  const { pageSlug, pageType } = usePageMeta();

  return useCallback(() => {
    const state = btoa(JSON.stringify({ slug: pageSlug, pageType }));

    const encodedCallbackUrl = encodeURIComponent(callbackDomain);

    window.location.href = `${authUrl}?client_id=${clientID}&redirect_uri=${encodedCallbackUrl}&response_type=${responseType}&scope=${scope}&state=${state}`;
  }, [
    clientID,
    callbackDomain,
    authUrl,
    responseType,
    scope,
    pageSlug,
    pageType,
  ]);
}
